/*
 gnb.ts 25.09.15 create by 김동영
 사용자페이지의 gnb를 스토어로 만들어 firstdepth에 1차메뉴, children에 2차메뉴를 뿌려준다.
 */

import { defineStore } from 'pinia';
import type {HeaderGnbMenuType} from "~/types/layout/gnb";

export const useGnbStore = defineStore('gnb', {
    state: () : HeaderGnbMenuType => ({
        firstdepth : [
            {
                id : 1,
                label : '사업공고',
                url : '/business/ntis/list',
                children : [
                    {id : 11, label : 'NTIS 사업공고', url : '/business/ntis/list'},
                    {id : 12, label : '울산시 사업공고', url : '/business/ulsan/list'},
                ]
            },
            {
                id : 2,
                label : 'R&D통계',
                url : '/statistics/rnd/list',
                children : [
                    {id : 21, label: '국가R&D사업통계', url: '/statistics/rnd/list?tab=1'},
                    {id : 22, label: '지역R&D사업통계', url: '/statistics/rnd/list?tab=2'},
                    {id : 23, label: '혁신기업통계', url: '/statistics/rnd/list?tab=3'},
                ]
            },
            {
                id : 3,
                label : '자료실',
                url : '/data/kbrief/list',
                children : [
                    {id : 31, label: 'K-브리프', url : '/data/kbrief/list'},
                    {
                        id: 32,
                        label: 'U-브리프',
                        url: '/data/ubrief/list',
                        aliases: ['/data/uribrief', '/data/uccibrief'],
                    },
                    {
                        id : 33,
                        label: '발간물',
                        url : '/data/archive/list',
                    },
                ]
            },
            {
                id : 4,
                label : 'UTIS소개',
                url : '/community/introduce',
                children : [
                    {id: 41, label: 'UTIS소개', url: '/community/introduce'},
                    {id: 42, label: '공지사항', url: '/community/notice/list'},
                ]
            },
            {
              id : 5,
              label : '사이트맵',
              url : '/etc/sitemap',
              showgnb : false,
              children : [
                  {id: 51, label: '사이트맵', url : '/etc/sitemap'},
              ]
            },
            {
                id : 6,
                label : '통합검색',
                url : '/etc/totalsearch',
                showgnb : false,
            },
        ]
    }),


});